// Fonte de verdade dos domínios FCamara no front.
// Usado para: (1) forçar login via Microsoft 365 na tela de login e
// (2) impedir alteração de e-mail no perfil. Mantido em sincronia com
// back/src/shared/utils/fcamara.ts.
export const FCAMARA_DOMAINS = ['fcamara.com', 'fcamara.com.br'] as const

/** True se o e-mail pertence a um domínio FCamara (case-insensitive). */
export function isFCamaraEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  return FCAMARA_DOMAINS.some((domain) => normalized.endsWith('@' + domain))
}
